export type WebSearchResource = {
	tableName: string;
	label: string;
	icon: string;
};

export type WebSearchMeta = {
	page: number;
	pageSize: number;
	totalRecords: number;
};

export type WebSearchGroup = {
	index: string;
	label?: string;
	data: any[];
	meta: WebSearchMeta;
};

export const WEB_SEARCH_RESOURCES: WebSearchResource[] = [
	{ tableName: 'projects', label: 'Your projects', icon: 'cube' },
	{ tableName: 'agents', label: 'Your agents', icon: 'robot' },
	{ tableName: 'templates', label: 'Marketplace projects', icon: 'cube' },
	{ tableName: 'agent_templates', label: 'Marketplace agents', icon: 'robot' },
];

export const WEB_SEARCH_TABLES = ['projects', 'agents', 'templates', 'agent_templates'];
export const PUBLIC_SEARCH_TABLES = ['templates', 'agent_templates'];

export const webSearchResource = (tableName = '') =>
	WEB_SEARCH_RESOURCES.find(resource => resource.tableName === tableName);

export const webSearchTitle = (result: any) =>
	result.title || result.name || result.query || result.email || result.uuid || `Result #${result.id}`;

export const webSearchSubtitle = (result: any) =>
	result.tagline || result.description || result.owner?.name || result.email || result.uuid || '';

export const webSearchResult = (result: any) => ({
	...result,
	title: webSearchTitle(result),
	tagline: webSearchSubtitle(result),
});

export const webSearchGroup = (group: Partial<WebSearchGroup>, tableName = ''): WebSearchGroup => ({
	index: group.index || tableName,
	data: group.data || [],
	meta: group.meta || { page: 0, pageSize: 0, totalRecords: 0 },
});

export const webSearchGroups = (groups: Partial<WebSearchGroup>[] = [], tableNames = WEB_SEARCH_TABLES) =>
	tableNames.map(tableName => webSearchGroup(groups.find(group => group.index === tableName) || {}, tableName));

export const webSearchGroupTotal = (groups: WebSearchGroup[] = []) =>
	groups.reduce((total, group) => total + (group.meta?.totalRecords || 0), 0);

export const webSearchGroupResults = (groups: WebSearchGroup[] = []) =>
	groups.flatMap(group => group.data.map(result => webSearchResult({ ...result, index: group.index })));

export const webSearchPath = (result: any) => {
	return result.webPath || result.appPath || '';
};
